import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center bg-background">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <span className="h-2 w-2 animate-typing-bounce rounded-full bg-muted-foreground" />
          <span className="h-2 w-2 animate-typing-bounce rounded-full bg-muted-foreground [animation-delay:.18s]" />
          <span className="h-2 w-2 animate-typing-bounce rounded-full bg-muted-foreground [animation-delay:.36s]" />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
};
